// extracted by mini-css-extract-plugin
export default {"web-wrap":"Web_web-wrap__lngnl"};